export type Collection = {
  id: string;
  title: string;
  subtitle: string;
  reason: string;
  filmIds: string[];
  cover: string;
  editor: string;
};

export const collections: Collection[] = [
  {
    id: "youth",
    title: "那些年我们笑过又哭过的青春",
    subtitle: "从「色即是空」开始的韩式青春喜剧谱系",
    reason:
      "以最狼狈的告白为起点，串起九十年代末到千禧年初的校园成长片。它们都用夸张的身体喜剧包裹成长的不适，笑完后才发现自己也在里面。",
    filmIds: ["1", "2", "11"],
    cover:
      "https://readdy.ai/api/search-image?query=Nostalgic%20editorial%20still%20life%20of%20a%20university%20dorm%20desk%2C%20old%20cassette%20player%2C%20stickers%2C%20a%20photo%20strip%2C%20warm%20afternoon%20light%20and%20deep%20navy%20shadows%2C%20soft%20film%20grain%2C%20minimal%20composition&width=900&height=700&seq=sjs-coll-youth&orientation=landscape",
    editor: "编辑部 / 林一",
  },
  {
    id: "silence",
    title: "沉默的力量：无对白叙事专题",
    subtitle: "用动作、空间与停顿讲完一个故事",
    reason:
      "当人物不再说话，画面才开始承担叙事。这个专题收录四部把沉默当作语言的影片，适合想理解镜头如何表达情绪的人。",
    filmIds: ["4", "3", "8"],
    cover:
      "https://readdy.ai/api/search-image?query=Minimalist%20cinematic%20interior%20with%20a%20single%20chair%20and%20long%20shadow%20across%20a%20pale%20floor%2C%20empty%20window%2C%20muted%20grey%20and%20warm%20cream%20tones%2C%20quiet%20melancholic%20atmosphere%2C%20film%20grain&width=900&height=700&seq=sjs-coll-silence&orientation=landscape",
    editor: "编辑部 / 周叙",
  },
  {
    id: "city",
    title: "城市里的温柔与遗憾",
    subtitle: "华语都市情感片的四个经典切面",
    reason:
      "从台北公寓到香港走廊，再到贵州山城，城市改变了人的关系，也保住了人的体面。四部作品，四种关于错过与理解的方式。",
    filmIds: ["9", "10", "5", "8"],
    cover:
      "https://readdy.ai/api/search-image?query=Rainy%20city%20street%20at%20night%20seen%20through%20a%20window%2C%20neon%20warm%20reflections%20on%20wet%20pavement%2C%20a%20single%20umbrella%2C%20deep%20amber%20and%20muted%20teal%20palette%2C%20soft%20grain%2C%20melancholic%20urban%20mood&width=900&height=700&seq=sjs-coll-city&orientation=landscape",
    editor: "编辑部 / 陈墨",
  },
  {
    id: "seasons",
    title: "一年四季，一日三餐",
    subtitle: "在食物与季节里重新学会生活",
    reason:
      "如果最近有点累，从这两部开始。它们不解决任何问题，只是认真地把一日三餐做得好吃一点，然后你会觉得日子还能继续。",
    filmIds: ["7", "6"],
    cover:
      "https://readdy.ai/api/search-image?query=Rustic%20wooden%20kitchen%20table%20with%20seasonal%20fruits%2C%20fresh%20herbs%2C%20ceramic%20bowls%2C%20linen%20cloth%2C%20warm%20sunlight%20through%20a%20lattice%20window%2C%20earthy%20green%20and%20amber%20tones%2C%20calm%20editorial%20photography&width=900&height=700&seq=sjs-coll-seasons&orientation=landscape",
    editor: "编辑部 / 苏禾",
  },
];

export const siteStats = [
  { label: "收录影视作品", value: "1,280+" },
  { label: "演员与主创资料", value: "3,600+" },
  { label: "编辑专题", value: "86" },
  { label: "年深度策展", value: "12" },
];

export const teamMembers = [
  {
    name: "林一",
    role: "主编 / 影史研究",
    bio: "长期从事亚洲类型片研究，负责站内影视资料的核校与专题策展，相信好资料应当经得起反复查证。",
  },
  {
    name: "周叙",
    role: "内容编辑 / 影像分析",
    bio: "专注影像语言与叙事结构拆解，负责剧情介绍与镜头注释栏目的撰写，习惯把抽象感受说成具体画面。",
  },
  {
    name: "苏禾",
    role: "社区与资料整理",
    bio: "维护演员、主创与奖项的关联档案，同时处理读者来信与勘误，让每一条资料都能追溯到出处。",
  },
];